export type TrainingModuleSettings = {
  isAdmin?: boolean
  settingsAccess?: boolean
  settingsExternalTrainersAccess?: boolean
  settingsLocationsAccess?: boolean
  settingsCategoriesAccess?: boolean
  settingsObjectItemCategoryAccess?: boolean
  settingsCostCategoriesAccess?: boolean
  settingsEvaluationFormsAccess?: boolean
  learningPathAccess?: boolean
}

export const TRAINING_SETTING_ACCESS_KEYS = [
  'settingsExternalTrainersAccess',
  'settingsLocationsAccess',
  'settingsCategoriesAccess',
  'settingsObjectItemCategoryAccess',
  'settingsCostCategoriesAccess',
  'settingsEvaluationFormsAccess',
] as const

export type TrainingSettingAccessKey = typeof TRAINING_SETTING_ACCESS_KEYS[number]

const isTrainingAdmin = (training?: TrainingModuleSettings) =>
  !!training?.isAdmin || !!training?.settingsAccess

export const hasLearningPathSettingsAccess = (training?: TrainingModuleSettings) => {
  if (!training)
    return false
  if (training.learningPathAccess !== undefined)
    return !!training.learningPathAccess
  return isTrainingAdmin(training)
}

export const hasAnyTrainingSettingsAccess = (training?: TrainingModuleSettings) => {
  if (!training)
    return false
  if (isTrainingAdmin(training))
    return true
  if (hasLearningPathSettingsAccess(training))
    return true
  return TRAINING_SETTING_ACCESS_KEYS.some(key => !!training[key])
}

export const hasTrainingSettingAccess = (
  training: TrainingModuleSettings | undefined,
  key: TrainingSettingAccessKey,
) => {
  if (!training)
    return false
  if (training[key] !== undefined)
    return !!training[key]
  // New flags default to true for training admins when not yet persisted on the profile
  return isTrainingAdmin(training)
}
